// services/baseApi.js
/* eslint-disable */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_API_URL,
    prepareHeaders: (headers, { endpoint, body }) => {
      // Get the token from cookies and set the Authorization header
      const token = Cookies.get("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      // Handle Content-Type explicitly
      if (body instanceof FormData) {
        const boundary =
          "----CustomBoundary" + Math.random().toString(16).slice(2); // Custom boundary
        headers.set(
          "Content-Type",
          `multipart/form-data; boundary=${boundary}`
        );
      } else if (typeof body === "object" && body !== null) {
        headers.set("Content-Type", "application/json");
      }

      return headers;
    },
  }),
  tagTypes: [
    "Sessions",
    "Packages",
    "Instructors",
    "Clients",
    "Leads",
    "Attendance",
    "Schedules",
    "Forms",
    "Dashboard",
    "Interested",
    "Document",
    "LeadSource",
    "LeadStatus",
    "Category",
    "BookingStatus",
    "SessionTypes",
  ],
  endpoints: () => ({}), // Define your endpoints here
});

export default baseApi;
